"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isTimeExpired = void 0;
function isTimeExpired(time, duration) {
    return Date.now() - duration >= time;
}
exports.isTimeExpired = isTimeExpired;
//# sourceMappingURL=helpers.js.map